import { z } from 'zod'

import {
  DateZod,
  PiloteBaseRecordZod,
  PiloteInstitutionRecordZod,
  PiloteLocationRecordZod,
  PilotePersonRecordZod,
  PiloteRegionRecordZod,
  PiloteTransportRequestRecordZod,
} from '../../common'

import { PiloteTeamMemberRecordZod, PiloteTeamRecordZod, PiloteTeamVolunteerRecordZod } from './records'

export const PiloteTeamZod = z.object({
  timestamp: DateZod.nullable().optional(),
  team: PiloteTeamRecordZod,
  escort: PiloteTeamMemberRecordZod,
  escort_volunteer: PiloteTeamVolunteerRecordZod,
  escort_person: PilotePersonRecordZod,
  driver: PiloteTeamMemberRecordZod,
  driver_volunteer: PiloteTeamVolunteerRecordZod,
  driver_person: PilotePersonRecordZod,
  partner: PiloteTeamMemberRecordZod,
  partner_volunteer: PiloteTeamVolunteerRecordZod,
  partner_person: PilotePersonRecordZod,
  starting_location: PiloteLocationRecordZod.nullable(),
  available_at_institution: PiloteInstitutionRecordZod.nullable(),
  available_at_location: PiloteLocationRecordZod.nullable(),
  available_at_region: PiloteRegionRecordZod.nullable(),
  transport_request: PiloteTransportRequestRecordZod.nullable(),
  base: PiloteBaseRecordZod.nullable(),
})
